function switchTab(tab) {
  return {
    type: 'SWITCH_TAB',
    value: tab,
  };
}

export { switchTab as default };
